import Vue from 'vue'
import Vuex from 'vuex'
import Axios from 'axios'
import VueAxios from 'vue-axios'

Vue.use(Vuex)
Vue.use(VueAxios, Axios)

import router from '../router/index.js'

export default new Vuex.Store({

    state: {
        activities: "",
        extrasdata: "",
        
        selected_activity: "",
        selected_activity_color: "",
        selected_arrangement: "",
        selected_extras: [],

        no_persons: "",
        reservation_date: "",
        reservation_time: "17:00",

        client_name: "",
        client_email: "",
        client_phone: "",
        
        order_comments: "",
        coupon_code: "",
        coupon_status: [],
        price: "",

        form_valid: false,
        summary_valid: false,
        order_status: false,
        success_message: "",
        lock_persons: false,

        newsletter: false,

    },

    getters: {

        getActivityData (state) {

            return state.activities;

        },

        getArrangementsData (state) {
            
            if(state.selected_activity){
                return state.activities[state.selected_activity].arrangements;
            } 

            return "";

        },

        getSelectedActivity (state) {

            return state.selected_activity;

        },

        getSelectedArrangementID (state) {

            return state.selected_arrangement;

        },

        getSelectedArrangement (state) {

            if(state.selected_activity && state.selected_arrangement){
                return state.activities[state.selected_activity].arrangements[state.selected_arrangement];
            }

            return "";

        },

        getActivityPrice(state, getters){

            return getters.getSelectedArrangement.price * state.no_persons;
        },

        getActivityColor(state){

            return state.selected_activity_color;
        },
        
        getNoPersons(state){

            return state.no_persons;
        },

        getSelectedExtras(state){

            return state.selected_extras;

        },

        getSelectedExtrasPrice(state){

            var total = 0;

            state.selected_extras.forEach(function (product) {
                    total += parseFloat(product.price) * product.quantity;
                    // console.log()
            });

            return total;
        },

        getCouponCode(state){

            return state.coupon_code;
        },

        getReservationDate(state){

            return state.reservation_date;
        },

        getReservationTime(state){

            return state.reservation_time;
        },

        getExtrasData (state) {

            return state.extrasdata;

        },

        getClientName (state) {

            return state.client_name;

        },

        getClientEmail (state) {

            return state.client_email;

        },

        getClientPhone (state) {

            return state.client_phone;

        },

        getOrderComments (state) {

            return state.order_comments;

        },

        getCouponStatus(state){

            return state.coupon_status;
        },

        getOrdertotal(state, getters) {

            var total = 0;
            const coupon_status = state.coupon_status;

            if(coupon_status.is_valid == true){

                if(coupon_status.type == "flat"){

                    total = (getters.getActivityPrice + getters.getSelectedExtrasPrice) - coupon_status.amount;

                } else {

                    total = (getters.getSelectedExtrasPrice + getters.getActivityPrice) * (coupon_status.amount / 100);

                } 

            } else {

              total = getters.getActivityPrice + getters.getSelectedExtrasPrice;

            }

            return total;
        },

        getReservationValid(state){

            if(state.form_valid && state.summary_valid){ return true; }

        },

        getOrderStatus(state){

            return state.order_status;

        },

        getSuccessMessage(state){

            return state.success_message;

        },

        getLockPerons(state){

            return state.lock_persons;

        },

        getNewsletter(state){

            return state.newsletter;

        },

    },

    actions: {

        fetchProductData({commit}){

            return new Promise((resolve) => {
                    
                Axios.get('/wp-json/order/v1/products')
                .then(response => {

                    commit('setActivityData', response.data.products.activities)
                    commit('setExtrasData', response.data.extras)
                    resolve(response)

                })

            })


        },

        checkCoupon({ commit, state }){

            Axios.post('/wp-json/order/v1/coupons', {form_id: 7, coupon_code: state.coupon_code })
            .then(response => {
                
                commit('setCouponStatus', response.data);
      
            });
      
        },

        submitOrder: function({ commit }, formdata){

            Axios.post('/wp-json/order/v1/order', {form_id: 8, formdata })
            .then(response => {
                
                if(response.data.status == "OK"){
                    commit('completeOrder', response);
                    const el = document.body;
                    el.classList.add('order-success');
                }

            })

        },


    },

    mutations: {

        setActivityData(state, response){

            state.activities = response
        },

        setActivity(state, response){

            state.selected_arrangement = ""
            state.selected_activity = response.activity
            state.selected_activity_color = state.activities[response.activity].activity_color;

            if(!response.init){ router.push({query: { keuze_activiteit: response.activity}}); }
            
        },

        setArrangement(state, response){

            state.selected_arrangement = response
            router.push({query: { keuze_activiteit: state.selected_activity, keuze_arrangement: response}})

        },

        addExtra(state, product){
            
            const cart_item = state.selected_extras.find(p => p.id === product.id)

            if (!cart_item) {
                state.selected_extras.push(product);
            } else {
                cart_item.quantity = product.quantity
            }

        },

        deleteExtra(state, product){
            
            const cart_item = state.selected_extras.indexOf(product);
            state.selected_extras.splice(cart_item, 1);

        },

        setNoPersons(state, response){

            state.no_persons = response
        },

        setReservationDate(state, response){

            state.reservation_date = response
        },

        setReservationTime(state, response){

            state.reservation_time = response
        },

        setExtrasData(state, response){

            state.extrasdata = response
        },

        selectProduct(state, response){

            state.selected_product = response
        },

        setClientName(state, response){

            state.client_name = response
        },

        setClientEmail(state, response){

            state.client_email = response
        },

        setClientPhone(state, response){

            state.client_phone = response
        },

        setOrderComments(state, response){

            state.order_comments = response
        },

        setCouponCode(state, response){

            state.coupon_code = response
        
        },

        setCouponStatus(state, response){

            state.coupon_status = response
        
        },
    
        formValid(state, valid){
    
            state.form_valid = valid;
        },

        summaryValid(state, valid){
    
            state.summary_valid = valid;
        },
        
        completeOrder(state, response){

            state.order_status = 'success';
            state.success_message = response.data.message;
        },

        lockPersons(state, response){
            state.lock_persons = response;
        },

        setNewsletter(state, response){
            state.newsletter = response;
        },
        
    },


});


// WEBPACK FOOTER //
// ./scripts/vue/store/index.js